module.exports = __webpack_public_path__ + "img/00032.7ece8f46.webp";